import React from 'react';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const PageHeader = ({ title, showButtons = true }) => {
  return (
    <Navbar style={{ backgroundColor: '#3f51b5' }} variant="dark" expand="lg" className="mb-4 shadow rounded-bottom">
      <Container>
          <div  className="d-flex justify-content-between w-100 align-items-center">
            <h1 className="mb-0" style={{ fontSize: '1.8rem', fontWeight: '500', color: 'whitesmoke' }}>
              {title}
            </h1>
          </div>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          {showButtons && (
            <Nav>
              <Link to="/profile" className="nav-link">
                <Button variant="light" className="mx-1">
                  Profile
                </Button>
              </Link>
              <Link to="/logout" className="nav-link">
                <Button variant="danger" className="mx-1">
                  Logout
                </Button>
              </Link>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default PageHeader;
